var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { safeAssign } from "./safe-assign";
export class RosterTargetAnalysisEntryDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], RosterTargetAnalysisEntryDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisEntryDTO.prototype, "dayOfWeek", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], RosterTargetAnalysisEntryDTO.prototype, "dayOfWeekName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisEntryDTO.prototype, "departmentId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], RosterTargetAnalysisEntryDTO.prototype, "departmentName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisEntryDTO.prototype, "targetHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisEntryDTO.prototype, "plannedHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisEntryDTO.prototype, "finalHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisEntryDTO.prototype, "headcount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisEntryDTO.prototype, "unassignedShifts", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisEntryDTO.prototype, "unassignedHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisEntryDTO.prototype, "unassignedPercent", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisEntryDTO.prototype, "hoursDeviation", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisEntryDTO.prototype, "hoursDeviationPercent", void 0);
export class RosterTargetAnalysisSummaryDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisSummaryDTO.prototype, "totalTargetHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisSummaryDTO.prototype, "totalPlannedHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisSummaryDTO.prototype, "totalFinalHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisSummaryDTO.prototype, "overallDeviationPercent", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisSummaryDTO.prototype, "totalUnassignedShifts", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisSummaryDTO.prototype, "totalUnassignedHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisSummaryDTO.prototype, "totalUnassignedPercent", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisSummaryDTO.prototype, "daysAnalyzed", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisSummaryDTO.prototype, "departmentCount", void 0);
export class RosterTargetAnalysisDepartmentSummaryDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisDepartmentSummaryDTO.prototype, "departmentId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], RosterTargetAnalysisDepartmentSummaryDTO.prototype, "departmentName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisDepartmentSummaryDTO.prototype, "totalTargetHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisDepartmentSummaryDTO.prototype, "totalPlannedHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisDepartmentSummaryDTO.prototype, "totalFinalHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisDepartmentSummaryDTO.prototype, "deviationPercent", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisDepartmentSummaryDTO.prototype, "totalUnassignedShifts", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisDepartmentSummaryDTO.prototype, "totalUnassignedHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisDepartmentSummaryDTO.prototype, "totalUnassignedPercent", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisDepartmentSummaryDTO.prototype, "daysWithData", void 0);
export class RosterTargetAnalysisGroupedEntryDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "departmentId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "departmentName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "groupLabel", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "dayOfWeek", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "dayOfWeekName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "weekStart", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "weekLabel", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "targetHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "plannedHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "finalHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "headcount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "unassignedShifts", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "unassignedHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "unassignedPercent", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "hoursDeviation", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "hoursDeviationPercent", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisGroupedEntryDTO.prototype, "daysInGroup", void 0);
export class RosterTargetAnalysisDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], RosterTargetAnalysisDTO.prototype, "from", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], RosterTargetAnalysisDTO.prototype, "to", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], RosterTargetAnalysisDTO.prototype, "venueId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], RosterTargetAnalysisDTO.prototype, "venueName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RosterTargetAnalysisDTO.prototype, "groupBy", void 0);
__decorate([
    Expose(),
    Type(() => RosterTargetAnalysisEntryDTO),
    __metadata("design:type", Array)
], RosterTargetAnalysisDTO.prototype, "entries", void 0);
__decorate([
    Expose(),
    Type(() => RosterTargetAnalysisGroupedEntryDTO),
    __metadata("design:type", Array)
], RosterTargetAnalysisDTO.prototype, "groupedEntries", void 0);
__decorate([
    Expose(),
    Type(() => RosterTargetAnalysisDepartmentSummaryDTO),
    __metadata("design:type", Array)
], RosterTargetAnalysisDTO.prototype, "departmentSummaries", void 0);
__decorate([
    Expose(),
    Type(() => RosterTargetAnalysisSummaryDTO),
    __metadata("design:type", RosterTargetAnalysisSummaryDTO)
], RosterTargetAnalysisDTO.prototype, "summary", void 0);
//# sourceMappingURL=roster-target-analysis.dto.js.map